import { useContext, useState } from 'react';
import { LanguageContext } from '../../context/LanguageContext';
import './TranslationBtn.scss';
import languages from '../../data/languages';

function TranslationBtn() {
  const { languageIndex, toggleLanguage } = useContext(LanguageContext);
  let [open, setOpen] = useState(false);

  function toggleDropdown() {
    setOpen(!open);
  };

  // Ternário que ajuda a mudar a lingua secundária
  // (Essa lógica só funciona para dois idiomas)
  const alternateIndex = languageIndex === 0 ? 1 : 0;

  return (
    <div id='custom-select' onMouseEnter={toggleDropdown} onMouseLeave={toggleDropdown}>
      <ul id='languages'>
        <li>
          <img src={languages[languageIndex].img} alt={languages[languageIndex].alt} />
          <span>{languages[languageIndex].language}</span>
        </li>
        {open && (
          <li onClick={() => { toggleLanguage(); setOpen(false); }}>
            <img src={languages[alternateIndex].img} alt={languages[alternateIndex].alt} />
            <span>{languages[alternateIndex].language}</span>
          </li>
        )}
      </ul>
    </div>
  );
}

export default TranslationBtn;
